import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Image from 'next/image'
import React, { useEffect, useRef } from 'react'

const Glob = () => {

    const globRef = useRef(null)

    useEffect(() => {
        // Register ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);

        // Set initial position explicitly
        gsap.set(globRef.current, {
            top: 200,
            left: -85,
            x: 0, // Match CSS transform: translate(-50%, -50%)
            y: 0,
            scale: 1.4,
            rotate: 0,
            opacity: 0.8,
        });

        // Create a timeline for the ball animation
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: globRef.current,
                start: "top 40%",
                end: "bottom bottom",
                scrub: 1,
                // markers: true,
            },
        });

        // Animation sequence
        tl
            // Move to Hero Section: Center
            .to(globRef.current, {
                top: 300,
                left: -60,
                x: 0,
                y: 0,
                scale: 2,
                rotate: -90,
                duration: 2,
                opacity: 0.6,
                ease: "power1.in",
            })
            .to(globRef.current, {
                top: 700,
                left: -100,
                x: 0,
                y: 0,
                scale: 3,
                rotate: -90,
                duration: 2,
                opacity: 1,
                ease: "power1.in",
            }).to(globRef.current, {
                top: 1200,
                left: -400,
                x: 0,
                y: 0,
                scale: 3,
                rotate: -90,
                duration: 1,
                opacity: 1,
                ease: "power1.in",
            })

        // Cleanup ScrollTrigger on component unmount
        return () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, []);

    return (
        <Image data-component-id="src/components/animate/Glob.tsx:79:8" data-component-path="src/components/animate/Glob.tsx" data-component-line="79" data-component-file="Glob.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2FGlob.png%22%2C%22alt%22%3A%22Background%20Element%22%2C%22className%22%3A%22hidden%20sm%3Ablock%20w-%5B364px%5D%20h-%5B650px%5D%20object-contain%20opacity-40%20%22%7D"
            ref={globRef}
            width={364}
            height={650}
            src="/images/Glob.png"
            alt="Background Element"
            className="hidden sm:block w-[364px] h-[650px] object-contain opacity-40 "
            style={{
                position: "absolute",
                top: "200px",
                left: "-85px",
                scale: 1,
                opacity: 0.5
                // transform: "translate(-50%, -50%)",
            }}
        />
    );
};

export default Glob;